
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import Patient from '@/types/Patient';
    import { PrintPayload } from '@/store/types';
    import jspm from '@/services/PrintManager';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        computed: {
            ...mapState('globals', ['rules', 'formatDate']),
            ...mapState('patient', ['loaders', 'patientData']),
            ...mapGetters('authentication', ['getSystemEinstellung', 'isAllowed']),
        },
        methods: {
            ...mapActions('patient', ['printEtiketten']),
        },
    })
    export default class PatientEtikettenDetail extends Vue {
        @Prop() visible!: boolean;

        public patientData!: Patient;
        public formatDate!: (input: string | null) => string | null;
        public printEtiketten!: (payload: PrintPayload) => string | null;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public count = 1;
        public isUntersuchungen = true;

        public get patient(): string[] {
            const patientData = this.patientData as Patient;
            const geburstdatum = this.formatDate(patientData.geburtsdatum);

            return [
                patientData.name,
                geburstdatum ? 'geb. ' + geburstdatum : null,
                [patientData.plz, patientData.ort].filter((str) => str).join(' '),
                patientData.strasse,
            ].filter((str) => str) as string[];
        }

        public onClickPrint(): void {
            const etikettvariante = String(this.getSystemEinstellung('etikettvariante').value ?? '').toLowerCase();

            // Defaults
            let paperName = '62mm x 29mm';
            let printRotation = jspm.printer?.manager.PrintRotation.Rot90;

            // Client specific overrides
            switch (etikettvariante) {
                case 'stemberger':
                    paperName = '38mm x 90mm';
                    printRotation = jspm.printer?.manager.PrintRotation.None;
                    break;
                case 'muw':
                    // CUPS expects custom media names in this format.
                    paperName = 'Custom.54x25mm';

                    // TODO: For windows, perhaps use this one
                    // paperName = '54mm x 25mm';
                    printRotation = jspm.printer?.manager.PrintRotation.None;
                    break;
                default:
                    break;
            }

            this.printEtiketten({
                count: this.count,
                printRotation,
                // TODO: Papiergröße überprüfen (vielleicht in Arbeitsplatz/Systemdaten einstellen?)
                paperName,
            });
        }
    }
